var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownHover(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 9,
    transform: "rotate(90 15 15)",
    fill: "#1e88e5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 15C27 8.38298 21.617 3 15 3C8.38298 3 3 8.38298 3 15C3 21.617 8.38298 27 15 27C21.617 27 27 21.617 27 15ZM14.293 18.707L9.29302 13.707C9.09802 13.512 9 13.256 9 13C9 12.744 9.09802 12.488 9.29302 12.293C9.684 11.902 10.316 11.902 10.707 12.293L15 16.586L19.293 12.293C19.684 11.902 20.316 11.902 20.707 12.293C21.098 12.684 21.098 13.316 20.707 13.707L15.707 18.707C15.316 19.098 14.684 19.098 14.293 18.707Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownHover);
export default __webpack_public_path__ + "static/media/dropdownHover.8d9e8177a9ceabdbdb865f96a8a00a54.svg";
export { ForwardRef as ReactComponent };